import React from 'react'
import Layout from './Layout'
import { Link } from 'react-router-dom'

export default function EngineeringVisualization() {
  return (
    <Layout page={<div>
      <h1>Engineering Visualization</h1>
      <h3>Question Bank Solutions</h3>
      <ul>
        <Link to='/file/ev/1643941290132_EV_Solution_Bank.pdf'>1643941290132_EV_Solution_Bank.pdf</Link>
      </ul>
      <h6><Link to='/contact'>Contact developer</Link> to add more notes.</h6>

    </div>} />
  )
}
